import type { GoalRealismClassification } from '@onflow/shared';

interface RealismCheckResultProps {
  classification: Exclude<GoalRealismClassification, 'realistic'>;
  message: string;
  suggestedDate: string | null;
  onUseSuggestion: () => void;
  onKeepDate?: () => void;
}

const DATE_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

function formatSuggestedDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, DATE_FORMAT);
}

export function RealismCheckResult({
  classification,
  message,
  suggestedDate,
  onUseSuggestion,
  onKeepDate,
}: RealismCheckResultProps) {
  return (
    <div
      className={`realism-check realism-check--${classification}`}
      role="alert"
      aria-live="polite"
    >
      <div className="realism-check-header">
        <span aria-hidden className="realism-check-icon">
          ⚠
        </span>
        <span className="realism-check-label">Heads up</span>
      </div>
      <p className="realism-check-message">{message}</p>
      {suggestedDate && (
        <p className="realism-check-suggested">
          Suggested target date: <strong>{formatSuggestedDate(suggestedDate)}</strong>
        </p>
      )}
      <div className="realism-check-actions">
        {suggestedDate && (
          <button type="button" className="btn-secondary" onClick={onUseSuggestion}>
            Use suggestion
          </button>
        )}
        {onKeepDate && (
          <button type="button" className="btn-primary" onClick={onKeepDate}>
            Keep my date
          </button>
        )}
      </div>
    </div>
  );
}
